import { debounce } from 'lodash';
import { apolloClient } from '@/plugins/apollo';
import {
  GetScreeningCountsForReview,
  GetReviewScreeningInsights,
} from '@/graphql';

const DEBOUNCE_MS = 500;

// Refetch the review's screening count summaries. The summaries are embedded
// on the normalized Review, so a network-only fetch rewrites them in-cache and
// every tab badge + the status footer re-renders reactively. Debounced so rapid
// voting collapses into one light aggregate query.
export const refreshScreeningCounts = debounce((reviewId) => {
  if (!reviewId) return;
  apolloClient
    .query({
      query: GetScreeningCountsForReview,
      variables: { id: reviewId },
      fetchPolicy: 'network-only',
    })
    .catch(() => {
      // Best-effort: a failed count refresh must not surface an error to the
      // user mid-screening. The next vote (or navigation) will retry.
    });
}, DEBOUNCE_MS);

// Refetch the review's AI-status training stats / "~ Relevant Remaining"
// estimate. These are sourced from a separate query and hand-copied onto the
// review model, so unlike the counts above they only refresh when this query
// re-emits. Debounced so rapid voting collapses into one light query.
export const refreshScreeningInsights = debounce((reviewId) => {
  if (!reviewId) return;
  apolloClient
    .query({
      query: GetReviewScreeningInsights,
      variables: { id: reviewId },
      fetchPolicy: 'network-only',
    })
    .catch(() => {
      // Best-effort: a failed insights refresh must not surface an error to
      // the user mid-screening. The next vote (or navigation) will retry.
    });
}, DEBOUNCE_MS);
